@if (auth.isLoading$ | async) {
  <div>
    <div class="adm-loading">
      <bodyanalytics-loading-spinner spinnerTitle="Loading" />
    </div>
  </div>
} @else if (isPortalRoute()) {
  <!-- Authenticated `/auth/...` portal routes: full admin shell (top-nav,
       mobile drawer/tab bar). -->
  <bodyanalytics-admin-shell />
} @else {
  <!-- Public / pre-auth routes (home, login, error, access-denied — #1553
       Scope A): standalone, no admin chrome. -->
  <router-outlet />
}

<!-- App-wide toast notifications (#1156) — rendered once, all admin routes -->
<bodyanalytics-toast-container />
